

import { Section, SectionDetail } from "Types";
import { ApiService } from "./ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export const SectionApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getListOfSections: builder.query<Section[], void>({
      query: () => ({
        url: `/sections`,
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<Section[]>) => res.results ?? [],
    }),

    getSectionDetail: builder.query<
      SectionDetail,
      {
        sectionString: string | undefined;
        activePage: number;
        pageSize: number;
      }
    >({
      query: ({ sectionString, activePage, pageSize }) => ({
        url: `/sections/${sectionString}?pageNo=${activePage}&productsCount=${pageSize}&includeProducts=true`,
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<SectionDetail>) => res.results,
    }),
  }),
});

export const { useGetListOfSectionsQuery, useGetSectionDetailQuery } =
  SectionApiSlice;
